<template>
    <div>
        <label
            v-if="label"
            class="block text-sm text-theme-muted mb-1 font-semibold"
            >{{ label }}</label
        >
        <div class="flex flex-wrap items-center gap-1 px-2">
            <div
                v-for="(item, index) in arrayString"
                :key="index"
                class="bg-theme-primary rounded-lg px-1 flex items-center"
            >
                <small>{{ item }}</small>
                <button
                    v-if="enabled"
                    class="bg-theme-primary rounded-lg btn ml-1 p-1/2"
                    @click="deleteItem(index)"
                >
                    <small> ❌ </small>
                </button>
            </div>
            <div
                v-if="arrayString.length === 0"
                class="text-sm text-theme-muted"
            >
                Sin {{ label }}
            </div>
        </div>

        <div v-if="enabled" class="flex items-end gap-2 mt-2">
            <custom-input
                ref="inputArrayInput"
                v-model="keyword"
                class="w-full min-w-0"
                :label="`Agregar (Separa por ',')`"
                @enter="addNewItem"
            />
            <app-button icon border class="shrink-0" @click="addNewItem">
                ➕
            </app-button>
        </div>
    </div>
</template>

<script>
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "ArrayStringSelector",
    components: { CustomInput },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        label: {
            type: String,
            default: () => "",
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    emits: ["change"],
    data: () => ({
        arrayString: [],
        keyword: ""
    }),
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemsCurrent);
    },
    methods: {
        addNewItem() {
            if (this.keyword) {
                const newItems = this.keyword
                    .split(",")
                    .map((item) => item.trim())
                    .filter((item) => item);
                this.arrayString = [...this.arrayString, ...newItems].filter(
                    (value, index, self) =>
                        self.findIndex((item) => item === value) === index
                );
                this.keyword = "";
                this.onInput();
            }
        },
        deleteItem(index) {
            this.arrayString.splice(index, 1);
            this.onInput();
        },
        onInput() {
            this.$emit("change", this.arrayString);
        },
        setInput(value) {
            this.arrayString = value.filter((item) => item);
        }
    }
};
</script>
